module.exports = __webpack_public_path__ + "img/32.f35d7073.gif";